import type { CoverageGroupSettings } from '@/lib/monitoring-coverage'

/** A watched group's settings, one block per type: the type with its count, then the setting names. */
export function GroupSettings({ settings }: { settings: CoverageGroupSettings[] }) {
  return (
    <div className="flex flex-col gap-6 py-2">
      {settings.map(type => (
        <section key={type.id} aria-label={type.typeLabel} className="flex flex-col gap-2">
          <h4 className="m-0 flex items-baseline gap-3 text-body font-semibold text-text-primary">
            <span>{type.typeLabel}</span>
            <span className="text-helper font-normal tabular-nums text-text-helper">{type.count}</span>
          </h4>
          {type.names.length > 0 && (
            <ul className="m-0 flex list-none flex-col gap-1 p-0 text-body text-text-secondary">
              {type.names.map(name => (
                <li key={name}>{name}</li>
              ))}
            </ul>
          )}
        </section>
      ))}
    </div>
  )
}
